import React from "react";
import ContentBankItem from "../ContentBankItem/ContentBankItem";
import * as PathRouter from '../../../../models/PathRoute';
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { throwApiError } from "../../../lms-shared/store/error-handling-actions";
import ToastMessage from "../../../UI/ToastMessage";
import { lessonsApi } from "../../../../utils";
import { ObjectTypeEnum } from "../../../../models/ObjectTypeEnum";
import ForwardLessonBtn from "../../MaterialLibrary/ForwardLessonBtn";
import classes from './MyMaterials.module.css';

const LessonTypeData = ({ myMaterialList, setMessage, changeLibraryData, fromPopup, selectedMaterial, setSelectedMaterial }) => {

    const dispatch = useDispatch();
    const { texts } = useSelector(state => state.translate);
    const homeUrl = useSelector(state => state.application.homeUrl);
    const navigate = useNavigate();

    function lessonItemClick(item) {
        if (setSelectedMaterial) {
            setSelectedMaterial(item);
        }
        else {
            navigate(`${homeUrl}/${PathRouter.LESSONS}/${item.id}`, {
                state: {
                    studyGroupId: myMaterialList?.filteredData.studyGroupId
                }
            });
        }
    }

    function handleEditName(e, id, newName, setIsEditName) {
        e.stopPropagation()
        if (newName && newName !== '') {
            const data = {
                id,
                name: newName
            }
            lessonsApi.lessonsUpdatePost({ lessonUpdateInput: data }, (error, resdata, response) => {
                if (error) {
                    dispatch(throwApiError({ userMessage: texts.lessonsUpdateError, error: error, statusCode: response?.statusCode, message: "lessonsUpdatePost " + error.message, level: 2, component: "LessonTypeData", line: 74 }))
                } else {
                    setIsEditName(false)
                    const newObj = myMaterialList.filteredData.find(m => m.id == id);
                    changeLibraryData('UPDATE', { ...newObj, name: newName });
                }
            })
        }
    }

    function handleDelete(e, id, showPopup, close, setMessagePopup) {
        e.stopPropagation();
        lessonsApi.lessonsDeleteIdPost(id, (error, resdata, response) => {
            if (error) {
                dispatch(throwApiError({ userMessage: texts.MessageContentDeleteProjectStatus, error: error, statusCode: response?.statusCode, message: "lessonsDeleteIdPost " + error.message, level: 2, component: "LessonTypeData", line: 70 }))
            }
            else {
                showPopup(<ToastMessage text={texts.MessageContentSuccessDeleteLessonStatus} color="green" close={close} />)
                changeLibraryData('DELETE', id);
            }
        })
        setMessagePopup(false)
    }

    const handleForward = m => <ForwardLessonBtn ViewText={texts.copylinkOflesson} setMessage={setMessage} data={m} type={ObjectTypeEnum.Lesson} />

    return (
        <>
            {myMaterialList?.filteredData?.sort((a, b) => new Date(b.createdDate) - new Date(a.createdDate)).map((m, i) =>
                <div key={i} className={`${classes.ContentBankItemWrapper} ${selectedMaterial && selectedMaterial === m.id ? classes.Select : ``} `}>
                    <ContentBankItem contentBankItem={m} showProjectPopup={!fromPopup} setContentBankItem={lessonItemClick} handleDelete={handleDelete} handleEditName={handleEditName} handleForward={handleForward(m)} />
                </div>
            )}
        </>
    )
}
export default LessonTypeData;